import { VoiceErrorBoundary } from 'screens/BrandKits/components/BrandVoice/AddVoice/VoiceErrorBoundary'
import { Modal, StackModalProps, useModals } from 'almanac-ui/Modal'
import Styles from 'screens/BrandKits/components/BrandVoice/AddVoice/AddVoice.module.scss'
import { Importer } from 'screens/BrandKits/components/BrandVoice/ContentSourcePicker/ContentSourcePicker'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Step2, voiceParams } from 'screens/BrandKits/components/BrandVoice/AddVoice/Step2'
import { AddVoiceModalProps } from './Types'
import { VoiceData } from 'hooks/useBrandVoices'
import cx from 'classnames'
import { AnalyseContentModalProps } from 'screens/BrandKits/components/BrandVoice/AddVoice/AnalyseContentModal'

type OnNext = ({
  voiceData,
}: {
  voiceData: Partial<Omit<VoiceData, 'voiceParams'>> & { voice_params: voiceParams }
}) => void

export interface Props
  extends AddVoiceModalProps,
    Pick<StackModalProps, 'close'>,
    Pick<AnalyseContentModalProps, 'onAnalyse'> {
  content: string
  selectedImporter: Importer
  onNext: OnNext
  bodyClassName?: string
}

export const AnalysingContentModal = ({
  close,
  onComplete,
  content,
  selectedImporter,
  onNext,
  bodyClassName,
  onAnalyse,
}: Props) => {
  const { closeModal: closeAlmanacModal } = useModals()
  const { isMobile } = useResponsiveDesign()

  const closeModal = (voiceId?: number) => {
    onComplete?.(voiceId)

    close()
  }

  return (
    <VoiceErrorBoundary onAnalyse={onAnalyse}>
      <Modal.Root
        size="sm"
        blaze
        withDefaultBg={isMobile}
        onClose={closeModal}
        onPressOutside={closeModal}
        aria-label="Analyzing Content"
        bodyClassName={cx(Styles.modalBody, bodyClassName)}
      >
        <Modal.Content blaze>
          <Step2
            importer={selectedImporter}
            key="step2"
            sample={content}
            onNext={(voiceParams) => {
              onNext({ voiceData: { voice_params: voiceParams } })
            }}
            onPrev={closeAlmanacModal}
          />
        </Modal.Content>
      </Modal.Root>
    </VoiceErrorBoundary>
  )
}
